export default "__VITE_ASSET__10dd373e__"